import React from "react"
import { Link } from "gatsby"

import MainLayout from "../components/layout"
import SEO from "../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Constants from "../constants/news.json"
import backgroundImg from "../images/pricing/pricing.svg"

import Intro from "../components/SubPages/IntroSubPages/introSubPages"
import NewsContent from "../components/SubPages/NewsPage/NewsContent/newsContent"

const NewsPage = () => (
  <MainLayout>
    <SEO title="News" />
    <Intro
      title="Let us introduce you to the revolutionary new ways of doing online screen recording."
      blueTitle="CONTACT SALES"
      blueLink=""
      // yellowTitle="BUILD PARTNERSHIP"
      yellowLink=""
      background={backgroundImg}
    />
    <NewsContent
      description={
        <div>
          <p>
            In the simplest and fastest way,{" "}
            <a href="http://screenapp.io/">ScreenApp.IO</a> gives you 100& FREE
            and INSTANTANEOUS captures for you to record, and download your BEST
            high-quality videos.
          </p>{" "}
          <p>
            The evolution of technology continues to develop everyday and, with
            it, our screen app was born. We want to give you the most intuitive
            options to your recordings, whether they are your desktop, browser
            tabs, screens with or without audio, entire screens or even just an
            application window. With a few clicks and very easy steps, you
            quickly select your preferred audio method, share your screen, start
            and finish your recording and download or trim it.
          </p>
          <p>
            But that's not all: besides being able to quickly save your
            recording to your Windows or Linux (Ubuntu) computer, we are by your
            side in making sure you have a plan B in case some of your
            recordings get lost. That is, we're here to cloud backup your
            captures and give you access to our LOCAL STORAGE also for FREE.
            Because no one wants to have the job done and then miss it, we offer
            the best solution to make sure that it won't happen to you again.
            Our video library feature is the final step in guaranteeing you
            capture everything that you want on your screen without any
            frustrating setbacks. Very soon, we'll be launching this AMAZING new
            feature so stay tuned! In the meantime, enjoy using our unique
            online screen recorder tool as many times as you want! You're really
            only one click away to start the "RES" process: to RECORD, EDIT and
            SHARE your computer screen.
          </p>
          <p>Just like that. Evolve alongside us!</p>
        </div>
      }
    />
  </MainLayout>
)

export default NewsPage
